import { render, staticRenderFns } from "./ModalAttachmentFilename.vue?vue&type=template&id=6a3b4c54&"
import script from "./ModalAttachmentFilename.vue?vue&type=script&lang=js&"
export * from "./ModalAttachmentFilename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports